import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Slider from 'react-slick'
import { images } from '../../../assets'
// import $ from 'jquery'
import { Intro1 } from './Intro1'
import { ServiceFee } from './ServiceFee'

const Main = () => {
  const navi = useNavigate()

  const gotoApply = () => {
    navi('apply/2817vk02', { state: { isMain: true } })
  }

  const [headerHeight, setHeaderHeight] = useState(0)
  function headerDetect() {
    setHeaderHeight(document.querySelector('.main_wrap').clientHeight)
  }
  useEffect(() => {
    headerDetect()
  }, [])

  const [headerScrollPosition, setHeaderScrollPosition] = useState(0)
  const handleScroll = () => {
    setHeaderScrollPosition(window.scrollY)
  }
  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  gsap.registerPlugin(ScrollTrigger)
  useEffect(() => {
    //mobileBtn
    gsap.to('.btn_section', {
      duration: 0.1,
      opacity: 1,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: '#section1',
        start: 'top center',
        scrub: true,
      },
    })

    //main
    const mainTl = gsap.timeline({ defaults: { ease: 'power3.out', translateY: 0, opacity: 1 } })
    mainTl.to('.main_tit .tit', { delay: 0.5 })
    mainTl.to('.main_tit .sub_tit', {})
    mainTl.to('.main_wrap .btn_application', {})

    //section1
    const sectionTl1 = gsap.timeline({
      defaults: { duration: 0.2, ease: 'power3.out', translateY: 0, opacity: 1 },
      scrollTrigger: { trigger: '#section1', start: 'top center', end: 'bottom top' },
    })
    sectionTl1.to('#section1 .contents_tit .sub_tit', {})
    sectionTl1.to('#section1 .contents_tit .tit', {})
    document.querySelectorAll('.review_wrap').forEach((review, i) => {
      sectionTl1.to(review, { duration: 0.2 })
    })

    //section2
    const sectionTl2 = gsap.timeline({
      defaults: { duration: 0.2, ease: 'power3.out', translateY: 0, opacity: 1 },
      scrollTrigger: { trigger: '#section2', start: 'top center', end: 'bottom top' },
    })
    sectionTl2.to('#section2 .contents_tit .sub_tit', {})
    sectionTl2.to('#section2 .contents_tit .tit', {})
    sectionTl2.to('#section2 .contents_slide', {})

    //section3
    const sectionTl3 = gsap.timeline({
      defaults: { duration: 0.2, ease: 'power3.out', translateY: 0, opacity: 1 },
      scrollTrigger: { trigger: '#section3', start: 'top center', end: 'bottom top' },
    })
    sectionTl3.to('#section3 .contents_tit .sub_tit', {})
    sectionTl3.to('#section3 .contents_tit .tit', {})
    document.querySelectorAll('#section3 .card_wrap').forEach((card, i) => {
      sectionTl3.to(card, { duration: 0.1 })
    })

    //section4
    const sectionTl4 = gsap.timeline({
      defaults: { duration: 0.2, ease: 'power3.out', translateY: 0, opacity: 1 },
      scrollTrigger: { trigger: '#section4', start: 'top center', end: 'bottom top' },
    })
    sectionTl4.to('#section4 .contents_tit .sub_tit', {})
    sectionTl4.to('#section4 .contents_tit .tit', {})
    document.querySelectorAll('#section4 .center').forEach((center, i) => {
      sectionTl4.to(center, { duration: 0.2 })
    })

    //section5
    const sectionTl5 = gsap.timeline({
      defaults: { duration: 0.2, ease: 'power3.out', translateY: 0, opacity: 1 },
      scrollTrigger: { trigger: '#section5', start: 'top center', end: 'bottom top' },
    })
    sectionTl5.to('#section5 .contents_tit .sub_tit', {})
    sectionTl5.to('#section5 .contents_tit .tit', {})
    document.querySelectorAll('#section5 .card_wrap').forEach((card, i) => {
      sectionTl5.to(card, { duration: 0.1 })
    })

    //section6
    const sectionTl6 = gsap.timeline({
      defaults: { duration: 0.2, ease: 'power3.out', translateY: 0, opacity: 1 },
      scrollTrigger: { trigger: '#section6', start: 'top center', end: 'bottom top' },
    })
    sectionTl6.to('#section6 .contents_tit .sub_tit', {})
    sectionTl6.to('#section6 .contents_tit .tit', {})
    sectionTl6.to('#section6 .qna_wrap img', {})
    document.querySelectorAll('.qna').forEach((qna, i) => {
      sectionTl6.to(qna, { duration: 0.2 })
    })

    //section7
    gsap.to('#section7 .contents_wrap', 0.3, {
      translateY: 0,
      opacity: 1,
      ease: 'power3.out',
      scrollTrigger: { trigger: '#section7', start: 'top center', end: 'bottom top' },
    })
  }, [])

  //intro1
  const intro1 = gsap.timeline({
    defaults: { duration: 0.2, ease: 'power3.out', translateY: 0, opacity: 1 },
    scrollTrigger: { trigger: '#intro1', start: 'top center', end: 'bottom top' },
  })    
  intro1.to('#intro1 .phone-area', {})  
  intro1.to('#intro1 .intro-area', {})  
  

  const settings = {
    arrows: false,
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 1,
  }

  return (
    <div className="Main SubPages" onScroll={handleScroll}>
      <div className={headerScrollPosition < headerHeight ? 'header_wrap' : 'header_wrap scroll'}>
        <div className="header">
          <a href="#" className="logo_spgeR"></a>
          <div className="scroll_btn">
            <button className="btn_application" onClick={gotoApply}>
              서비스 이용 신청하기
            </button>
          </div>
        </div>
      </div>
      <div className="main_wrap">
        <div className="main_tit">
          <p className="tit">
            사장님, <br /> 댓글 관리에서 해방시켜 드립니다
          </p>
          <p className="sub_tit">지금부터 스폰지R과 함께하세요!</p>
          <button className="btn_application" onClick={gotoApply}>
            서비스 이용 신청하기
          </button>
        </div>
      </div>

      <div className="section_wrap">
        <div className="section" id="section1">
          <div className="contents_wrap">
            <div className="contents">
              <div className="contents_tit">
                <p className="sub_tit">정성스럽게 댓글을 달아</p>
                <p className="tit">
                  사장님의 리뷰를 <br /> 관리해 드립니다.
                </p>
              </div>
            </div>
            <div className="contents">
              <div className="review_wrap">
                <div className="review_box">
                  <div className="review_user">
                    <div className="user_img">
                      <img src={images.review_img01} alt={images.review_img01} />
                    </div>
                    <div className="user_name">
                      <p className="name bold">아몬드밭</p>
                      <img src={images.review_srats} alt={images.review_srats} />
                    </div>
                    <div className="user_review_date">1주일 전</div>
                  </div>
                  <p className="txt">
                    약속시간에 맞춰서 시켰는데 배달이 엄청 빨리 왔어요! <br />
                    보쌈 양이 많았고, 막국수랑 양념 따로 주신 것도 넘 좋았어요~ <br />
                    야채도 씻어서 깨끗이 보내주셨구요! 떡볶이도 서비스 같지 않게 맛있었어요❣️
                    <br />
                    오랜만에 근사한 점심 먹었네요!! 담에 또 시킬게요~~^^ 왕추천
                  </p>
                </div>
                <div className="reply_box">
                  <div className="reply_img">
                    <img src={images.review_img04} alt={images.review_img04} />
                  </div>
                  <div className="reply_txt">
                    <div className="name bold">사장님</div>
                    <div className="txt">
                      가장 맛있을 때 빠르게 배달되어 맛있게 드셨다니 다행입니다~
                      <br />
                      다른 손님들도 이 리뷰보고 주문 많이 할 것 같아요.
                      <br />
                      소중한 리뷰 감사 드리고 정말 맛있게 드셔주셔서 감사합니다. 👍
                      <br />
                    </div>
                  </div>
                </div>
              </div>

              <div className="review_wrap">
                <div className="review_box">
                  <div className="review_user">
                    <div className="user_img">
                      <img src={images.review_img02} alt={images.review_img02} />
                    </div>
                    <div className="user_name">
                      <p className="name bold">미스홈</p>
                      <img src={images.review_srats} alt={images.review_srats} />
                    </div>
                    <div className="user_review_date">3일 전</div>
                  </div>
                  <p className="txt">
                    김치찜 보쌈세트 너무 맛있게 잘먹었습니다^^
                    <br />
                    양도 푸짐하구요 가성비 짱이네요!! 번창하세요 또 시켜먹을게요~
                  </p>
                </div>
                <div className="reply_box">
                  <div className="reply_img">
                    <img src={images.review_img04} alt={images.review_img04} />
                  </div>
                  <div className="reply_txt">
                    <div className="name bold">사장님</div>
                    <div className="txt">
                      주문 감사드립니다 소중한 사진리뷰 따봉~!👍👍👍
                      <br />
                      만족한 식사 되셨나요 ^^ 항상 양과 맛 모두 최고가 될 수 있는 총각네가 되겠습니다~! 좋은 하루 되시고 또 이용 부탁드립니다~!❤️❤️❤️
                    </div>
                  </div>
                </div>
              </div>

              <div className="review_wrap">
                <div className="review_box">
                  <div className="review_user">
                    <div className="user_img">
                      <img src={images.review_img03} alt={images.review_img03} />
                    </div>
                    <div className="user_name">
                      <p className="name bold">제리제리</p>
                      <img src={images.review_srats} alt={images.review_srats} />
                    </div>
                    <div className="user_review_date">1일 전</div>
                  </div>
                  <p className="txt">
                    저번에 맛있게 먹어서 일주일도 안돼서 재주문 했어요!!!
                    <br />
                    저번에 막국수 소스가 흘러서 슬펐는데 요번엔 안 흐르고 깔끔하게 잘 왔어요😊
                    <br />
                    마늘보쌈 엄청 좋아하는데 은근 마늘 보쌈 잘하는 집이 없는데 딱 제 스타일이에요!👍🏻
                    <br />
                    고기도 두툼하고 부드럽고 마늘 소스가 묽지 않아서 마늘 본연의 맛도 느껴지고 보쌈김치랑 무는 말해 뭐해요!
                    <br />
                    보쌈집이 무난한 곳은 많은데 은근 맛있는 곳은 없어서 보쌈 러버로서 슬펐지만 맛집 발견해서 좋아요😆
                    <br />
                    요번엔 따로 마늘 소스 살짝 더달라고 안했더니 소스가 사알짝 모자라서 다음엔 더달라고 부탁드려야겠어요!
                    <br />
                    요번에도 맛있게 잘 먹었습니다! 꺼~~어억😋
                  </p>
                </div>
                <div className="reply_box">
                  <div className="reply_img">
                    <img src={images.review_img04} alt={images.review_img04} />
                  </div>
                  <div className="reply_txt">
                    <div className="name bold">사장님</div>
                    <div className="txt">
                      주문 감사드립니다. 소중한 장문의 리뷰 감동입니다~🥹
                      <br />
                      만족한 한 끼되셨다니 너무 기분이 좋네요^^ 담엔 소스 넉넉히 보내드리겠습니다~! 오늘 하루도 힘내시고 또 이용 부탁드립니다~!🙇‍♂️
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="section" id="section2">
          <div className="contents_wrap">
            <div className="contents">
              <div className="contents_tit">
                <p className="sub_tit">악성 리뷰를 포함하여 사장님께서</p>
                <p className="tit">
                  꼭 보셔야 할 리뷰를 <br /> 공유하고 소통합니다.
                </p>
              </div>
            </div>
            <div className="contents">
              <div className="contents_slide">
                <div className="slide_wrap">
                  <Slider {...settings} className="slide">
                    <div>
                      <img src={images.chat_img01} alt={images.chat_img01} />
                    </div>
                    <div>
                      <img src={images.chat_img02} alt={images.chat_img02} />
                    </div>
                    <div>
                      <img src={images.chat_img03} alt={images.chat_img03} />
                    </div>
                    {/* <div>
                      <img src={images.chat_img04} alt={images.chat_img04} />
                    </div> */}
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="section" id="section3">
          <div className="contents_wrap">
            <div className="contents">
              <div className="contents_tit">
                <p className="sub_tit">매월 정기 리포트를 통하여</p>
                <p className="tit">
                  사장님의 <br /> 리뷰 데이터를 <br /> 분석해 드립니다.
                </p>
                <p className="sub_txt">(현재 간단통계만 제공, 데이터 분석 페이지 추후 제공 예정)</p>
              </div>
            </div>
            <div className="contents">
              <div className="card_wrap">
                <img src={images.card_img01} alt={images.card_img01} />
                <div className="card_txt">
                  <p className="card_tit">데이터 추이</p>
                  <p>
                    전체 리뷰, 핵심 리뷰의 <span className="color_blue">증감 추이 분석</span>을 통해 보다 전략적인 매장 운영이 가능해집니다.
                  </p>
                </div>
              </div>
              <div className="card_wrap">
                <img src={images.card_img02} alt={images.card_img02} />
                <div className="card_txt">
                  <p className="card_tit">리뷰 요약</p>
                  <p>
                    고객의 의견을 한 눈에 확인할 수 있도록 <span className="color_blue">리뷰 요약 서비스</span>를 제공합니다.{' '}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Intro1/>
        <div className="section" id="section4">
          <div className="contents_wrap">
            <div className="contents center">
              <div className="contents_tit">
                <p className="sub_tit">고객과의 소통은 저희에게 맡기시고</p>
                <p className="tit">사장님은 장사에만 집중하세요!</p>
              </div>
            </div>
            <div className="contents center">
              <div className="floating_wrap">
                <img src={images.img01} alt={images.img01} />
                <img src={images.img02} alt={images.img02} />
                <img src={images.img03} alt={images.img03} />
              </div>
            </div>
            <ServiceFee/>
            
          </div>
        </div>

        <div className="section" id="section5">
          <div className="contents_wrap">
            <div className="contents left">
              <div className="contents_tit">
                <p className="sub_tit">스폰지R 요약</p>
                <p className="tit">
                  효과적인 리뷰 관리로 고객과 소통하여 <br /> 단골고객을 확보해 드립니다.
                </p>
              </div>
            </div>
            <div className="contents left">
              <div className="card_wrap">
                <img src={images.card_img01} alt={images.card_img01} />
                <div className="card_txt">
                  <p className="card_tit">리뷰 답변 관리</p>
                  <p>리뷰에 정성스럽게 댓글을 대신 달아 드립니다.</p>
                </div>
              </div>
              <div className="card_wrap">
                <img src={images.card_img02} alt={images.card_img02} />
                <div className="card_txt">
                  <p className="card_tit">악성리뷰 대처 및 알림</p>
                  <p>사장님께서 꼭 보셔야 할 리뷰를 공유하고 대처합니다.</p>
                </div>
              </div>
              <div className="card_wrap">
                <img src={images.card_img03} alt={images.card_img03} />
                <div className="card_txt">
                  <p className="card_tit">매월 정기 리뷰 분석 리포트</p>
                  <p>한달간의 데이터와 리뷰를 정리하여 분석한 리포트를 제공합니다.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="section" id="section6">
          <div className="contents_wrap">
            <div className="contents">
              <div className="contents_tit">
                <p className="sub_tit">서비스를 사용하고자 하실 때</p>
                <p className="tit">
                  도움이 될만한 <br /> Q&A들을 <br /> 모아봤어요.
                </p>
              </div>
            </div>
            <div className="contents">
              <div className="qna_wrap">
                <img src={images.timeline} alt={images.timeline} />
                <div className="qna_box">
                  <div className="qna question">
                    <p>Q</p>
                    <p>서비스 가입은 어떻게 하나요?</p>
                  </div>
                  <div className="qna answer">
                    <p>A</p>
                    <p>아래 서비스 이용 신청하기 또는 전화상담을 해주시면 담당자가 도와드립니다.</p>
                  </div>
                  <div className="qna question">
                    <p>Q</p>
                    <p>리뷰 답변이 다 다른가요?</p>
                  </div>
                  <div className="qna answer">
                    <p>A</p>
                    <p>
                      저희는 똑같은 리뷰를 복사 붙여넣기 하지 않습니다. <br />
                      매번 작성 시 매번 정성스럽게 사장님의 마음으로 고객님의 리뷰에 댓글을 작성합니다.
                    </p>
                  </div>
                  <div className="qna question">
                    <p>Q</p>
                    <p>추가비용이 있나요?</p>
                  </div>
                  <div className="qna answer">
                    <p>A</p>
                    <p>기본 서비스 비용 및 채널 추가 비용 외 별도의 추가비용은 없습니다.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section" id="section7">
          <div className="contents_wrap">
            <div className="contents">
              <div className="contents_tit">
                <p className="tit">
                  고객과의 연결고리, <br /> 스폰지R과 함께 만드세요
                </p>
                <button className="btn_application" onClick={gotoApply}>
                  서비스 이용 신청하기
                </button>
              </div>
            </div>

            <img src={images.img_07_01} alt={images.img_07_01} />
          </div>
        </div>

        <div className="btn_section">
          <button className="btn_application" onClick={gotoApply}>
            서비스 이용 신청하기
          </button>
        </div>
      </div>

      <div className="footer pc">
        <div className="home_footer_wrap">
          <div className="first_footer">
            <div className="spge">
              <p>“지역소상공인”과 함께하는</p>
              <p className="bold">(주)에스피지이</p>
            </div>
            <div className="address">
              <div>
                <p>서울시 강서구 마곡중앙로 161-8, C동 507호
                  (마곡동, 두산더랜드파크)</p>
                <div className="number">
                  <p>
                    <span>대표자명</span>김용회
                  </p>
                  <span className="slash">ㅣ</span>
                  <p>
                    <span>사업자번호</span>383-87-01230
                  </p>
                  <span className="slash">ㅣ</span>
                  <p>
                    <span>고객센터</span>050-7964-1000
                  </p>
                </div>
              </div>
              <a href="http://www.spge.kr" target="_blank" className="btn_spge">
                스폰지 서비스 보러가기
              </a>
            </div>
          </div>
          <div className="second_footer">
            <div className="logo_spge">
              <img src={images.logo_spge} alt={images.logo_spge} />
            </div>
            <p>Copyright © SPONGE 2023</p>
          </div>
        </div>
      </div>

      <div className="footer mobile">
        <div className="home_footer_wrap">
          <div className="first_footer">
            <div className="spge">
              <p>“지역소상공인"과 함께 하는</p>
              <p className="bold">(주)에스피지이</p>
            </div>
          </div>
          <div className="second_footer">
            <div className="logo_spge">
              <img src={images.logo_spge} alt={images.logo_spge} />
            </div>
            <a href="http://www.spge.kr" target="_blank" className="btn_spge">
              스폰지 서비스 보러가기
            </a>
          </div>
          <div className="third_footer">
            <div className="address">
              <div>
                <p>
                  서울시 강서구 마곡중앙로 161-8, C동 507호 <br /> (마곡동, 두산더랜드파크)
                </p>
                <div className="number">
                  <p>
                    <span>대표자명</span>김용회 <span className="slash">ㅣ</span>
                    <span>사업자번호</span>383-87-01230
                  </p>
                  <p>
                    <span>고객센터</span>050-7964-1000
                  </p>
                </div>
              </div>
            </div>
            <p>Copyright © SPONGE 2023</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export { Main }

